<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Boolean',
})
</script>
<template>
  <Tag :color="value ? 'success' : 'error'">{{ value ? text[0] : text[1] }}</Tag>
</template>

<script lang="ts" setup name="Boolean">
import { Tag } from '../../Tag'

withDefaults(
  defineProps<{
    value?: number | boolean
    text?: [string, string]
  }>(),
  {
    text: () => ['是', '否']
  }
)
</script>
